import { toast } from "react-toastify";
import { announceSessionExpiry } from "./sessionExpiry";

export default function handleError(error) {
  let message = error?.response?.data?.message || error?.message || "Unexpected Error Occured.";

  // `startsWith` rather than an exact match: klooma_db_api's internal write
  // surfaces (the catalogue movie-authoring endpoints among them) always send
  // "Validation Error." with a trailing period, proxied through Klooma-admin-api
  // unchanged - the exact-match check here never saw those per-field messages
  // at all, only the bare sentence.
  if (message.startsWith("Validation Error")) {
    message = "";
    const errors = error?.response?.data?.data || {};
    console.log("errors", errors);
    
    Object.keys(errors).forEach((key) => {
      if(Array.isArray(errors[key])) {
        errors[key].forEach((msg) => {
          message += msg + " \n";
        });
      } else {
        message += errors[key] + " \n";
      }
    });
  } else if (error?.response?.status === 403) {
    message = "You don't have access to this resource!";
  } else if (error?.response?.status === 401) {
    // Not this screen's news to break: the session ended, and every other
    // request it refused is in a catch of its own.
    if (window.setLoading) window.setLoading(false);
    announceSessionExpiry();
    return;
  }

  if (window.setLoading) window.setLoading(false);


  
  toast(message, {
    theme: "colored",
    type: "error",
  });
}
